/* eslint-disable react/prop-types */

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import Toolbar from "@material-ui/core/Toolbar";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import AppVersion from "../../AppComponents/AppVersion";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  menuTitle: {
    backgroundColor: "#34418b",
    fontFamily: "sans-serif",
    display: "flex",
    cursor: "default",
    fontSize: 16,
    fontWeight: 600,
    paddingBottom: 7,
    paddingTop: 7,
    paddingLeft: 5,
    paddingRight: 5,
    marginTop: 15,
  },
  menuItemPadding: {
    padding: "0 !important",
    cursor: "pointer",
  },
  menuItemText: {
    textAlign: "left",
    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: 25,
    color: "white",
    width: drawerWidth - 50,
    textOverflow: "clip",
    whiteSpace: "break-spaces",
  },
  active: {
    backgroundColor: "#34418b",
    paddingTop: 3,
    paddingBottom: 3,
  },
  drawer: {
    width: drawerWidth - 10,
  },
  drawerPaper: {
    width: drawerWidth,
    color: "#F5F5F5",
    backgroundColor: theme.palette.primary.main,
  },
  drawerContainer: {
    overflow: "auto",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
}));

const DrawerBar = (props) => {
  const classes = useStyles();
  return (
    <Fragment>
      <Drawer
        open={props.isDrawerOpen}
        onClose={() => props.toggleDrawerOpen()}
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <div>
            {props.featureList.map((feature) => {
              const { items = [] } = feature;
              return (
                <div key={feature.typeId} className={classes.menuListContainer}>
                  <Typography className={classes.menuTitle} noWrap variant="h6">
                    <div style={{ marginLeft: 10 }}>{feature.typeLabel}</div>
                  </Typography>
                  <MenuList
                    style={{
                      outline: "none",
                    }}
                  >
                    {items.map((option) => {
                      return (
                        <MenuItem
                          key={option.id}
                          className={`${classes.menuItemPadding}`}
                        >
                          <NavLink
                            onClick={() => {
                              props.toggleDrawerOpen();
                            }}
                            activeClassName={classes.active}
                            style={{ textDecoration: "none" }}
                            to={option.webUrl}
                          >
                            <Typography
                              className={`${classes.menuItemText}`}
                              noWrap
                              variant="body2"
                            >
                              {option.label}
                            </Typography>
                          </NavLink>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </div>
              );
            })}
          </div>
          <div
            style={{
              maxWidth: drawerWidth - 15,
              paddingBottom: 10,
              paddingTop: 20,
            }}
          >
            <Typography
              variant="body2"
              style={{ fontSize: 12, color: "white" }}
              align="center"
            >
              Copyright © {new Date().getFullYear()}. Color Kahar
              <br></br>(CK), Pakistan - All Rights Reserved
            </Typography>
            <AppVersion textColor="white" textSize={10} />
          </div>
        </div>
      </Drawer>
    </Fragment>
  );
};

DrawerBar.propTypes = {
  isDrawerOpen: PropTypes.bool,
  toggleDrawerOpen: PropTypes.func,
  featureList: PropTypes.array,
  viewValue: PropTypes.string,
};

DrawerBar.defaultProps = {
  isDrawerOpen: false,
  toggleDrawerOpen: (fn) => fn,
  featureList: [],
  viewValue: "",
};

export default DrawerBar;
